<template>
  <div class="clearfix">
    <div class="idol-quote-img" :style="{ backgroundImage: imgurl(quote.pic) }"></div>
    <div class="idol-quote-text">
      {{quote.quote}}
      <span>&mdash;  {{quote.name}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Quote",
  data: () => ({
  }),
  computed: {
    ...mapGetters("user", [
      "userData"
    ]),

    ...mapGetters("calendar", [
      "random_quote"
    ]),

    quote() {
      return this.random_quote(this.userData.selectedIdols);
    }
  },
  methods: {
    imgurl(img) {
      return `url('${img}')`;
    }
  }
}
</script>

<style>
.idol-quote-text {
  margin: 1em;
  padding-left: 64px;
}

.idol-quote-text > span {
  float: right;
}

.idol-quote-img {
  float: left;
  border-radius: 5px;
  width: 64px;
  height: 64px;
  background-position: 50% 25%;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
